export const DOWNLOAD_CLIENT_TYPE = {
  PC: 'PC',
  ANDROID: 'ANDROID',
  IOS: 'IOS',
};
